const layoutVariants = {
  BLOCKS: 'blocks',
  IFRAME: 'iframe',
};

export default layoutVariants;
